import { withFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Modal as BootstrapModal, Col, Grid, Row } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { createOrUpdatePasswordAPI, hasSignPasswordAPI } from "../../api/signature";
import { useAuthorization } from "../../components/Authorization/useAuthorization";
import { HandleApiError } from "../../components/Notifications/APIErrorHandler";
import { CreateOrUpdatePasswordForm, SignatureFrom } from "../../components/Signature/Signature";
import { getSignaturePasswordSchema, getSignSchema } from "../../components/Signature/SignatureValidation";
import { Spinner } from "../../components/Utils/Loaders";

export const SignatureModal = (props) => {
    const { isShowing, hide, isLoading, onSubmit } = props;
    const [isAPILoading, setIsLoading] = useState(true);
    const [, user] = useAuthorization();
    const [hasSignPassword, setHasSignPassword] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        hasSignPasswordAPI().then((res) => {
            if (!res?.data)
                setHasSignPassword(false);
            else
                setHasSignPassword(true);
        }).catch((error) => {
            console.log(error);
            HandleApiError(error);
        }).finally(() => setIsLoading(false));
    }, [isShowing]);

    const handleCreateOrUpdatePasswordSubmit = async (data) => {
        if (!data || data.newSignaturePassword === "")
            return;

        try {
            const res = await createOrUpdatePasswordAPI({ newSignaturePassword: data.newSignaturePassword });
            if (res)
                setHasSignPassword(true);
        }
        catch (error) {
            console.log(error);
            HandleApiError(error);
            setHasSignPassword(false);
        }
    }

    if (!isShowing)
        return null;

    const createPassContent = (<React.Fragment>
        <BootstrapModal show={true} onHide={hide} bsSize="medium" backdrop="static" >
            <BootstrapModal.Header closeButton>
                <BootstrapModal.Title>{t("signature.createUpdatePasswordTitle")}</BootstrapModal.Title>
            </BootstrapModal.Header>
            <BootstrapModal.Body>
                {
                    isLoading || isAPILoading ?
                        <Spinner /> :
                        <CreateOrUpdatePasswordFormik
                            currentUser={user.family_name ? `${user.family_name} ${user.given_name}` : user.email}
                            onSubmit={handleCreateOrUpdatePasswordSubmit}
                        />
                }
            </BootstrapModal.Body>
        </BootstrapModal>
    </React.Fragment>);
    const signContent = (<React.Fragment>
        <BootstrapModal show={true} onHide={hide} bsSize="medium" backdrop="static" >
            <BootstrapModal.Header closeButton>
                <BootstrapModal.Title>{t("signature.title")}</BootstrapModal.Title>
            </BootstrapModal.Header>
            <BootstrapModal.Body>
                {
                    isLoading ?
                        <Spinner /> :
                        <>
                            <Grid fluid>
                                <Row>
                                    <Col sm={12}>
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setHasSignPassword(false);
                                            }}
                                            className="text-primary"
                                            style={{
                                                fontWeight: 500,
                                                textDecoration: "none",
                                                cursor: "pointer",
                                            }}
                                            onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
                                            onMouseOut={(e) => (e.target.style.textDecoration = "none")}
                                        >
                                            {t("signature.forgotPassword")}
                                        </a>
                                    </Col>
                                </Row>
                            </Grid>
                            <SignatureContainerFormik
                                currentUser={user.family_name ? `${user.family_name} ${user.given_name}` : user.email}
                                onSubmit={onSubmit}
                            />
                        </>
                }
            </BootstrapModal.Body>
        </BootstrapModal>
    </React.Fragment>);

    if (hasSignPassword === true)
        return ReactDOM.createPortal(signContent, document.body);
    if (hasSignPassword === false)
        return ReactDOM.createPortal(createPassContent, document.body);

    return null;
};

const SignatureContainerFormik = withFormik({
    mapPropsToValues: () => ({ password: '' }),
    validationSchema: getSignSchema(),
    handleSubmit: (values, formikBag) => {
        formikBag.props.onSubmit(values);
    },
    displayName: 'SignatureFrom',
})(SignatureFrom);

const CreateOrUpdatePasswordFormik = withFormik({
    mapPropsToValues: () => ({ newSignaturePassword: '' }),
    validationSchema: getSignaturePasswordSchema(),
    handleSubmit: (values, formikBag) => {
        formikBag.props.onSubmit(values);
    },
    displayName: 'CreateOrUpdatePasswordForm',
})(CreateOrUpdatePasswordForm);